export interface User {
	id: string;
	name: string;
	email: string;
	avatar: string;
	neighborhood: string;
	bio: string;
	joinedAt: string;
	trustScore: number;
	totalLends: number;
	totalBorrows: number;
	responseRate: number;
	ratings: Rating[];
}

export interface Tool {
	id: string;
	ownerId: string;
	name: string;
	description: string;
	category: ToolCategory;
	images: string[];
	dailyRate: number;
	deposit: number;
	condition: ToolCondition;
	location: LatLng;
	neighborhood: string;
	availability: AvailabilitySlot[];
	createdAt: string;
	rating: number;
	reviewCount: number;
}

export interface LatLng {
	lat: number;
	lng: number;
}

export interface AvailabilitySlot {
	date: string;
	available: boolean;
}

export interface Booking {
	id: string;
	toolId: string;
	borrowerId: string;
	lenderId: string;
	startDate: string;
	endDate: string;
	status: BookingStatus;
	totalCost: number;
	deposit: number;
	depositReturned: boolean;
	createdAt: string;
	returnedAt?: string;
	damageReport?: DamageReport;
}

export interface Rating {
	id: string;
	fromUserId: string;
	toUserId: string;
	bookingId: string;
	score: number;
	comment: string;
	type: "lender" | "borrower";
	createdAt: string;
}

export interface DamageReport {
	id: string;
	bookingId: string;
	reporterId: string;
	description: string;
	severity: "minor" | "moderate" | "severe";
	images: string[];
	status: "pending" | "acknowledged" | "resolved" | "disputed";
	depositDeduction: number;
	createdAt: string;
	resolution?: string;
}

export type ToolCategory =
	| "power-tools"
	| "hand-tools"
	| "garden"
	| "automotive"
	| "cleaning"
	| "painting"
	| "plumbing"
	| "electrical"
	| "moving"
	| "other";

export type ToolCondition = "like-new" | "good" | "fair" | "worn";

export type BookingStatus =
	| "pending"
	| "confirmed"
	| "active"
	| "returned"
	| "completed"
	| "cancelled"
	| "disputed";

export const CATEGORY_LABELS: Record<ToolCategory, string> = {
	"power-tools": "Power Tools",
	"hand-tools": "Hand Tools",
	garden: "Garden",
	automotive: "Automotive",
	cleaning: "Cleaning",
	painting: "Painting",
	plumbing: "Plumbing",
	electrical: "Electrical",
	moving: "Moving",
	other: "Other",
};

export const CONDITION_LABELS: Record<ToolCondition, string> = {
	"like-new": "Like New",
	good: "Good",
	fair: "Fair",
	worn: "Worn",
};

export const BOOKING_STATUS_LABELS: Record<BookingStatus, string> = {
	pending: "Pending",
	confirmed: "Confirmed",
	active: "Active",
	returned: "Returned",
	completed: "Completed",
	cancelled: "Cancelled",
	disputed: "Disputed",
};
